import comp from "./Anecdotal";
export default comp;
